import { render, staticRenderFns } from "./OurSearchButton.vue?vue&type=template&id=0c1e414b&"
import script from "./OurSearchButton.vue?vue&type=script&lang=js&"
export * from "./OurSearchButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports